export enum FailureCategoryKey {
	ERROR = 'ERROR',
	PROBLEM = 'PROBLEM',
	WARNING = 'WARNING',
}
